import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';

export default function Redeem() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Pre-fill code and streamId from URL if present
  useEffect(() => {
    const urlCode = searchParams.get('code');
    if (urlCode) {
      setCode(urlCode.toUpperCase());
    }
  }, [searchParams]);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!code.trim()) return;

    setLoading(true);
    setError('');

    try {
      const streamId = searchParams.get('streamId');
      const res = await fetch('/api/access/redeem', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          code: code.trim().toUpperCase(),
          ...(streamId && { streamId })
        })
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || 'Failed to redeem code');
      }

      // Success - redirect to watch page
      navigate(`/watch/${data.streamId}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Invalid access code');
    } finally {
      setLoading(false);
    }
  }

  function formatCode(value: string) {
    // Remove non-alphanumeric characters and convert to uppercase
    return value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase().slice(0, 12);
  }

  return (
    <div className="center-page">
      <div className="center-card">
        <h1>Enter Access Code</h1>
        <p>Enter the 12-character code from your email to start watching.</p>

        {error && <div className="message message-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="text"
              className="form-input"
              placeholder="ABC123XYZ789"
              value={code}
              onChange={(e) => setCode(formatCode(e.target.value))}
              style={{
                textAlign: 'center',
                fontSize: '1.5rem',
                letterSpacing: '4px',
                fontFamily: 'monospace',
                textTransform: 'uppercase'
              }}
              maxLength={12}
              autoFocus
            />
            <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)', marginTop: '8px' }}>
              {code.length}/12 characters
            </p>
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%' }}
            disabled={loading || code.length < 6}
          >
            {loading ? 'Verifying...' : 'Start Watching'}
          </button>
        </form>

        <div style={{ marginTop: '30px', paddingTop: '20px', borderTop: '1px solid var(--border)' }}>
          <p style={{ fontSize: '0.9rem', color: 'var(--text-muted)' }}>
            Don't have a code?{' '}
            <Link to="/">Browse available streams</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
